import { render, staticRenderFns } from "./CreateWarehouseModal.vue?vue&type=template&id=b3dc407a&scoped=true&"
import script from "./CreateWarehouseModal.vue?vue&type=script&lang=js&"
export * from "./CreateWarehouseModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateWarehouseModal.vue?vue&type=style&index=0&id=b3dc407a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3dc407a",
  null
  
)

export default component.exports